import { getBrowserTimezone } from '../lib/DateTime.js';
import { InformationCircleIcon } from '@heroicons/react/24/outline/index.js';

const InfoMessageText = ({ children, className, showIcon }) => {
    return (
        <div
            className={`text-primary-700 ${className}`}
        >
            {showIcon && (
                <div className="flex">
                    <InformationCircleIcon className="w-5 h-5 mt-0.5 text-primary-700 mr-2 flex-shrink-0" />
                    <div>{children}</div>
                </div>
            )}
            {!showIcon && children}
        </div>
    );
};

export default InfoMessageText;
